export default __webpack_public_path__ + "static/media/delete-icon.977774e7.svg";